import { render, staticRenderFns } from "./AuthorizationDocument.vue?vue&type=template&id=49497c96&scoped=true"
import script from "./AuthorizationDocument.vue?vue&type=script&lang=js"
export * from "./AuthorizationDocument.vue?vue&type=script&lang=js"
import style0 from "./AuthorizationDocument.vue?vue&type=style&index=0&id=49497c96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49497c96",
  null
  
)

export default component.exports